// extracted by mini-css-extract-plugin
module.exports = {"flex":"col_flex_1pqt_"};